"use strict";var BgzfFilehandle = require('./bgzFilehandle');var _require =
require('./unzip'),unzip = _require.unzip,unzipChunk = _require.unzipChunk,unzipChunkSlice = _require.unzipChunkSlice;

module.exports = { BgzfFilehandle: BgzfFilehandle, unzip: unzip, unzipChunk: unzipChunk, unzipChunkSlice: unzipChunkSlice };